import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventAttendeeTicket } from '@models/events/event-attendee-ticket.model';
import { TranslateModule } from '@ngx-translate/core';
import { TicketOrderTicketOwnerDataDialog } from '../../dialogs/ticket-order-ticket-owner-data/ticket-order-ticket-owner-data.dialog';

@Component({
  selector: 'app-ticket-order-ticket-owner-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ticket-order-ticket-owner-card.component.html',
  styleUrl: './ticket-order-ticket-owner-card.component.scss',
})
export class TicketOrderTicketOwnerCardComponent {
  @Input() ticket!: EventAttendeeTicket;

  @Output() forwardTicket = new EventEmitter<EventAttendeeTicket>();

  constructor(private dialog: MatDialog) {}

  viewData() {
    this.dialog.open(TicketOrderTicketOwnerDataDialog, {
      maxWidth: '358px',
      maxHeight: '100vh',
      width: '100%',
      height: 'auto',
      data: {
        ticket: this.ticket,
      },
      panelClass: ['normal-dialog', 'new-normal-dialog'],
      backdropClass: '',
    });
  }

  onForwardTicket() {
    this.forwardTicket.emit(this.ticket);
  }
}
